<template>
	<QrcodeNavGridShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import QrcodeNavGridShell from '../shared/QrcodeNavGridShell.vue';
	import { qrcodeNavMixin } from '../shared/mixin.js';

	export default {
		name: 'GBlockQrcodeNavGrid',
		components: { QrcodeNavGridShell },
		mixins: [qrcodeNavMixin],
	};
</script>
